import React from 'react'
import EventsCard from './EventsCard'
import styled from 'styled-components';
import { Fade } from 'react-reveal';
import Entrepreneurs_Festival from '../../assets/img/Events/Entrepreneurs-festival.jpg' 

import event_card_img from '../../assets/img/Events/event-card.png'

function UpcomingEvent() {

    
    
  return (
      
      <Container className='container'>
          <Fade up>

        <h2 id='upcoming-events' className='text-center'>Upcoming Events</h2>
        <p className='text-center text-dark m-auto w-75 pb-5'>
        Come explore all our amazing events like  with industry peers that educate entrepreneurs how they can leverage their skills as well learn from them through hands-on workshops such when we come together under one roof.
        </p>
          </Fade>
          
        <Fade up>

        <div className="events-container">


        <EventsCard
                    title={<> Entrepreneurial Festival</>}
                    time='2:00 PM - 4:00 PM'
                    date='April 12, 2022'
                    location='Lalitpur'
                    image={event_card_img}
                    LinkID='entrepreneurs-festival'

        />
                <EventsCard title='Entrepreneurs Reunion'
                            time='11:00 PM'
                            date='March 22, 2022'
                            location='Lalitpur'
                            image={event_card_img}

        />
        <EventsCard title='Startup Buildup Conference'
                    time='11:00 PM'
                    date='March 22, 2022'
                    location='Lalitpur'  
                    image={event_card_img}
        />   
        </div>
        </Fade>
        
    </Container>
  )
}

export default UpcomingEvent
const Container = styled.div` 
#show-on-hover{
    color:black ;
    font-family:arial ;
    display:none ;
    
}
h1:hover #show-on-hover{
    /* display:flex ; */
    display:none ;
}

h1:hover #hide-on-hover{
    display:none ;
    color:black ;
}
    text-align:left ;
        .events-container{
            margin-top:50px ;
            display:grid ;
            grid-template-columns:repeat(auto-fit, minmax(300px,2fr));
            grid-gap:10px ;
        }
        p{
            /* line-height:6px ; */
        }
    
    #upcoming-events{
        color:#fa7525 ;
        margin-top:30px ;


    }

`